import React from 'react';
import { Input } from '../../ui/Input';
import { Button } from '../../ui/Button';
import { Plus, Trash2 } from 'lucide-react';

interface CollaboratorItem {
  id: string;
  name: string;
  email: string;
  role: string;
}

interface CollaboratorsStepProps {
  items: CollaboratorItem[];
  onChange: (items: CollaboratorItem[]) => void;
}

export function CollaboratorsStep({ items, onChange }: CollaboratorsStepProps) {
  const addRow = () => {
    onChange([...items, { id: crypto.randomUUID(), name: '', email: '', role: 'Fotografo' }]);
  };

  const removeRow = (id: string) => {
    onChange(items.filter(c => c.id !== id));
  };

  const updateRow = (id: string, field: keyof CollaboratorItem, value: string) => {
    onChange(items.map(c => c.id === id ? { ...c, [field]: value } : c));
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
      <p style={{ fontSize: 'var(--text-sm)', color: 'var(--color-text-muted)' }}>
        Inserisci i collaboratori fissi del tuo studio.
      </p>

      {items.map((collab) => (
        <div key={collab.id} style={{ display: 'flex', gap: '0.5rem', alignItems: 'flex-end' }}>
          <div style={{ flex: 1 }}>
            <Input label="Nome" value={collab.name}
              onChange={e => updateRow(collab.id, 'name', e.target.value)}
              placeholder="Mario Rossi" />
          </div>
          <div style={{ flex: 1 }}>
            <Input label="Email" value={collab.email}
              onChange={e => updateRow(collab.id, 'email', e.target.value)}
              placeholder="mario@studio.it" />
          </div>
          <div style={{ width: '8rem' }}>
            <Input label="Ruolo" value={collab.role}
              onChange={e => updateRow(collab.id, 'role', e.target.value)}
              placeholder="Fotografo" />
          </div>
          <button onClick={() => removeRow(collab.id)} style={{
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--color-text-muted)', padding: '0.5rem', marginBottom: '2px'
          }}>
            <Trash2 size={14} />
          </button>
        </div>
      ))}

      <Button variant="ghost" onClick={addRow} icon={<Plus size={14} />} style={{ alignSelf: 'flex-start' }}>
        Aggiungi collaboratore
      </Button>
    </div>
  );
}
